export { default as Benefit12PL } from 'quick-quote/v2/products/customs/12pl/components/benefit-summary-table/container'
